import Game from '../../Game';
import { ResourceDriver } from '../../Utility/Resource/ResourceManager';
import { AUDIO_PACKS, AUDIO_PATH } from '../Audio';

export const AUDIO_CLIP_AMBIENT = 'luckyTurnips/ambient.mp3';
export const AUDIO_CLIP_MUSIC = 'luckyTurnips/music.mp3';

export function queueLuckyTurnipsResources() {
    Game.resource.add(
        'LuckyTurnips',
        'resource/graphics/sprite_sheets/luckyturnips.json'
    );
    Game.resource.add(
        'luckyturnips_bg',
        'resource/graphics/backgrounds/luckyturnips_bg.jpg'
    );

    // Load all required audios from audio sprite sheet.
    // please take a look at README on resources/audio directory.

    // Load music.
    Game.resource.add(
        AUDIO_PACKS.luckyTurnipsSystem,
        undefined,
        ResourceDriver.SECONDARY
    );
    Game.resource.add(
        AUDIO_CLIP_AMBIENT,
        `${AUDIO_PATH}${AUDIO_CLIP_AMBIENT}`
    );
    Game.resource.add(
        AUDIO_CLIP_MUSIC,
        `${AUDIO_PATH}${AUDIO_CLIP_MUSIC}`
    );
}
